// Hooks
import useFormatBonusBalance from "hooks/useFormatBonusBalance";
import useTranslate from "hooks/useTranslate";

// Types
import {
  BONUS_ITEM,
  BONUS_TYPES,
  BonusListType,
  FREE_SPINS_STAGES,
} from "types/Bonus";

import "./styles.sass";
import { useCatalogsStore } from "stores/catalogs";

type BonusItemProps = {
  name: string;
  type: BONUS_ITEM;
  bonus: BonusListType;
  currency: string;
};

const BonusItem = (props: BonusItemProps) => {
  const { name, type, bonus, currency } = props;
  const currencies = useCatalogsStore((state) => state.currencies);

  const t = useTranslate();
  const formatBonus = useFormatBonusBalance();
  const isFreeSpins =
    "freeSpinsCount" in bonus && bonus.type === BONUS_TYPES.FREE_SPINS;

  // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
  const getData = (type: string) => {
    if (
      "freeSpinsCount" in bonus &&
      bonus.freeSpinStage === FREE_SPINS_STAGES.UNUSED
    ) {
      return `+${bonus.freeSpinsCount} FS`;
    }
    if (type === BONUS_ITEM.TOTAL_SPINS) {
      return "leftSpins" in bonus && bonus.leftSpins && bonus.leftSpins <= 0
        ? bonus.totalWager
        : `+${"totalSpins" in bonus ? bonus.totalSpins : ""} FS`;
    }
    if (type === BONUS_ITEM.REWARD) {
      const cur = currencies?.find((c) => c.isoCode === currency);
      return "reward" in bonus && (bonus.reward || bonus.reward === 0) && cur
        ? `${cur.sign} ${formatBonus(bonus.reward)}`
        : "";
    }
    if (type === BONUS_ITEM.NOMINAL || type === BONUS_ITEM.TRIGGER) {
      return "";
    }
    if (type === BONUS_ITEM.VALID) {
      return "startWagingDate" in bonus
        ? "24 h"
        : `${"duration" in bonus ? bonus.duration.toFixed(0) : ""} h`;
    }
  };

  return (
    <>
      <div className="BonusItem">
        <div className="BonusItem__name">{t(name)}</div>
        <div className="BonusItem__value">{getData(type)}</div>
      </div>
      {isFreeSpins ? (
        <div className="BonusItem__name">
          {t("bonus.card.front.text.freeSpins.available")}
        </div>
      ) : null}
    </>
  );
};

export default BonusItem;
